import mustache from 'mustache';
import * as bootstrap from 'bootstrap';

/**
 * Generic Mustache template string for a Bootstrap toast notification wrapper.
 * Used by multiple toast types with different body partials.
 * @type {string}
 */
const template =  `
    <div id="{{id}}" class="toast" role="alert" aria-live="assertive" aria-atomic="true">
      <div class="toast-header">
        <strong class="me-auto">{{title}}</strong>
        <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Sulje"></button>
      </div>
        <div class="toast-body">
            {{> bodyTemplate}}
        </div>
    </div>
`;

const addedToCartToastBodyTemplate = `
    <p>Ostoskoriin lisättiin {{product_title}} {{amount}} kpl</p>
    <p>EAN {{product_ean}}</p>
`;

const changeCartItemAmount = `
    <p>Ostoskorin tuotemäärä tuotteelle päivitettiin {{product_title}} {{amount}} kpl</p>
    <p>EAN {{product_ean}}</p>
`;

const deletedFromCartBodyTemplate = `
    <p>Tuote {{product_title}} poistettu ostoskorista</p>
    <p>EAN {{product_ean}}</p>
`;


export function showCartProductAmountChanged( { product_title, product_ean, amount } ) {
    const id = 'changedAmountToast';

    const toastHtml = mustache.render(template, {
        title: 'Tuotemäärä muokattu ostoskorissa',
        id,
        product_title,
        product_ean,
        amount,
    }, {
        bodyTemplate: changeCartItemAmount
    });

    showToast( id, toastHtml );
}

export function showDeletedFromCartToast( { product_title, product_ean } ) {
    const id = 'deletedFromCartToast';

    const toastHtml = mustache.render(template, {
        title: 'Tuote poistettu ostoskorista',
        id,
        product_title,
        product_ean,
    }, {
        bodyTemplate: deletedFromCartBodyTemplate
    });

    showToast( id, toastHtml );
}

/**
 * Renders and displays a Bootstrap toast notification when a product is added to the cart.
 *
 * @param {object} params - The product details to display in the toast.
 * @param {string} params.product_title - The name/title of the added product.
 * @param {string} params.product_ean - The EAN barcode of the added product.
 * @param {string|number} params.amount - The quantity added to the cart.
 * @param {string|number} params.recommended_price - The recommended price of the product.
 * @returns {void}
 */
export function showAddedCartToast( { product_title, product_ean, amount, recommended_price } ) {
    const id = 'addedToCartToast';

    const toastHtml = mustache.render(template, {
        title: 'Tuote lisätty ostoskoriin',
        id,
        product_title,
        product_ean,
        amount,
        recommended_price
    }, {
        bodyTemplate: addedToCartToastBodyTemplate
    });

    showToast( id, toastHtml );
}

function showToast( id, toastHtml ) {
    const toastContainer = document.getElementById('toast-container');
    toastContainer.innerHTML = toastHtml;
    const contentElement = document.getElementById(id);
    const toastBootstrap = bootstrap.Toast.getOrCreateInstance(contentElement);
    toastBootstrap.show()
}
